import UserNote from 'owa-mail-store/lib/store/schema/UserNote';

export default function getItemUserMarkupKeywords(
    itemUserHighlights: string[],
    itemUserNotes: UserNote[]
): string[] {
    const keywords = [];

    itemUserHighlights.forEach(highlight => keywords.push(highlight));

    itemUserNotes.forEach(note => {
        const keyword = note.keyword;
        // check there wasn't already a highlight with this keyword
        if (keywords.indexOf(keyword) == -1) {
            keywords.push(keyword);
        }
    });

    return keywords;
}
